import { useSuperAdminContext } from '../contexts/SuperAdminContext';

/** Shared super-admin flag (single RPC per session). Requires `SuperAdminProvider`. */
export function useSuperAdmin() {
  return useSuperAdminContext();
}